import React, { useState, useRef, useEffect, useMemo, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import AgGridTable from "../utilities/AgGridTable";
import ListPageHeader from "../utilities/ListPageHeader";
import { useMediaQuery, useTheme } from '@mui/material';

const RegionList = () => {
    const theme = useTheme();
     const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [selectedRows, setSelectedRows] = useState([]);
    const [rowData, setRowData] = useState();
    const gridRef = useRef();
    const navigate = useNavigate();
    const [error, setError] = useState();
    const [deleteDisable, setDeleteDisable] = useState(true);
    const [snackState, setSnackState] = useState(false);
    const [successMsg, setSuccessMsg] = useState();
    const [columnDefs, setColumnDefs] = useState([
        { field: 'id', enableRowGroup: true, headerName: 'Region Name' },
        { field: 'managers', enableRowGroup: true },
    ]);
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.region}`;

    const handlePurge = (e) => {

        selectedRows.map(async (row) => {
            try {
                await OAuthService.deleteData(url, row.id);
                setSuccessMsg("Data deleted Successfully")
                setSnackState(true);
                findRegion();
            } catch (error) {
                console.log("eror", error);
                setError(error.message);
            }
        })
    };

    const onGridReady = useCallback((params) => {
        findRegion()
        var columnToolPanel = gridRef.current.api.getToolPanelInstance('columns');
        columnToolPanel.expandColumnGroups();
    }, []);

    
    const onBtExport = useCallback(() => {
        const params = {
            fileName: 'Regions.xlsx',
            sheetName: 'Regions'
        }
        gridRef.current.api.exportDataAsExcel(params);
    }, []);

    const findRegion = async () => {
        try {
            const list = await OAuthService.getList(url + '?sort=id,desc&size=1000');
            const userList  = await OAuthService.getList(`${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}` + `?size=1000&sort=firstName,asc`);
            let users;
            userList.data?._embedded?.users.map((data, key) => {
                const lastName = data?.lastName ? data.lastName : '';
                const firstName = data?.firstName ? data.firstName : '';
                const name  = firstName + ' ' + lastName;
                users = {...users, [data.email]: name }
            });
            const data = list.data?._embedded?.regions.map((region) => {
                const managers = region?.managers?.map((data,index) => {
                    return users[data];
                })
                region.managers = managers?.join(" , ")
                return region;
            })
            setRowData(data)
        } catch (error) {
            console.log('error', error)
            setError(error.message);
        }
    }

    const onSelectionChanged = (params) => {
        setSelectedRows(params.api.getSelectedRows());
    }

 
 const goToRoleEdit = useCallback(
      (data) => {
        if (data?.id !== undefined) {
          navigate("/editRegion/" + data.id);
        }
      },
      [navigate],
    );
    const onRowDoubleClicked = (params) => {
      if (isMobile) return;
      goToRoleEdit(params?.data);
    };

    const onRowClicked = (params) => {
      if (!isMobile) return;
      goToRoleEdit(params?.data);
    };
    useEffect(() => {
        if (selectedRows.length > 0) {
            setDeleteDisable(false)
        } else {
            setDeleteDisable(true)
        }
    }, [selectedRows])

    return (
        <>
            <ListPageHeader
                componentName="Region"
                onBtExport={onBtExport}
                handlePurge={handlePurge}
                addPageLink="/addRegion"
                pageName="Region List"
                error={error}
                deleteDisable={deleteDisable}
                successMsg={successMsg}
                snackState={snackState}
                gridRef={gridRef}
            />
            <div className="w-full h-full">
                <AgGridTable
                    rowData={rowData}
                    columnDefs={columnDefs}
                    onGridReady={onGridReady}
                    onSelectionChanged={onSelectionChanged}
                    onRowDoubleClicked={onRowDoubleClicked}
                    onRowClicked={onRowClicked}
                    gridRef={gridRef}
                    paginationPageSize={10}
                    saveGridStateName={'regionList'}
                />
            </div>
        </>
    );
}

export default RegionList;
